export const updateKeysObject = (param, newKeys) => {
  return Object.keys(param).reduce((newObjectKeys, keyCurrent, index) => {
    const originalValue = param[keyCurrent];
    const newKey = newKeys[index];
    newObjectKeys[newKey] = originalValue;

    return newObjectKeys;
  }, {});
};